import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/ReadinessChecklist'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { readinessChecklist } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = readinessChecklist.name
  static widget = Widget
  static configure = createConfigure(readinessChecklist)
}
